import { RightOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import React from 'react';

const ActionCardsGrid = ({ actions = [], onCardClick }) => (
  <div className="bulk-action-cards-grid">
    {actions?.map((action) => (
      <Card key={action?.key} hoverable onClick={() => onCardClick(action)}>
        <div
          className="d-flex align-center justify-between"
          style={{ gap: 8 }}
        >
          <h3 className="m-0 bulk-action-card-title">{action?.title}</h3>
          {action?.hasNestedUi ? <RightOutlined /> : null}
        </div>
        <div className="mt-8">{action?.description}</div>
      </Card>
    ))}
  </div>
);

export default ActionCardsGrid;
